"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = require("./constants");
var ConsoleLogger = /** @class */ (function () {
    function ConsoleLogger() {
    }
    ConsoleLogger.trackError = function (type, message) {
        ConsoleLogger.loggingType[type](message);
    };
    ConsoleLogger.loggingType = (_a = {},
        _a[constants_1.LoggingType.error] = console.error,
        _a[constants_1.LoggingType.warn] = console.warn,
        _a[constants_1.LoggingType.info] = console.info,
        _a[constants_1.LoggingType.log] = console.log,
        _a);
    return ConsoleLogger;
}());
exports.default = ConsoleLogger;
